import {makeKey,update} from '../../../../utils/reducerOperations';
export function deleteOrganizationStarted(state, payload) {
    return makeKey(
        'deleteOrganizationApi',
        update(state.deleteOrganizationApi, {
            isProcessing: true,
            organizationId: payload.organizationId
        })
    );
}